module.exports = __webpack_public_path__ + "img/portfolio-08.442f1900.png";